import * as o from "react";
import { a as u } from "./index-DjWSt7QJ.js";
var s = o.useId || (() => {
}), n = 0;
function d(t) {
  const [a, r] = o.useState(s());
  return u(() => {
    r((e) => e ?? String(n++));
  }, [t]), t || (a ? `radix-${a}` : "");
}
export {
  d as u
};
